import { render } from "./WalletConnect.vue?vue&type=template&id=20019b6b&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"

import "./style.scss?vue&type=style&index=0&id=20019b6b&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20019b6b"]])

export default __exports__